import { PostedJobEffect } from 'src/app/recruiting/candidates/live-nurses-new/store/effects/posted-job.effect';
import { SubmittalNotesEffect } from 'src/app/recruiting/candidates/live-nurses-new/store/effects/submittal-notes.effect';
import { JobOptionsEffect } from 'src/app/recruiting/candidates/live-nurses-new/store/effects/job-options.effect';
import { JobPercentagesEffect } from 'src/app/recruiting/candidates/live-nurses-new/store/effects/job-percentages.effect';
import { DeleteJobEffect } from 'src/app/recruiting/candidates/live-nurses-new/store/effects/delete-job.effect';
import { AddJobEffect } from 'src/app/recruiting/candidates/live-nurses-new/store/effects/add-job.effect';
import { AddNoteEffect } from 'src/app/recruiting/candidates/live-nurses-new/store/effects/add-note.effect';
import { DeleteSubmittalEffect } from 'src/app/recruiting/candidates/live-nurses-new/store/effects/delete-submittal.effect';
import { SubmittalVerballyAcceptEffect } from 'src/app/recruiting/candidates/live-nurses-new/store/effects/verbally-accept.effect';

export const LiveNursesEffects = [
    PostedJobEffect,
    SubmittalNotesEffect,
    JobOptionsEffect,
    DeleteJobEffect,
    AddJobEffect,
    AddNoteEffect,
    DeleteSubmittalEffect,
    JobPercentagesEffect,
    SubmittalVerballyAcceptEffect
];
